import api from './api';

/**
 * Subscription Service
 * Handles all subscription-related API calls for users
 */
const subscriptionService = {
    /**
     * Get all available subscription plans
     * @returns {Promise<Object>}
     */
    getPlans: async () => {
        return api.get('/user/subscriptions/plans');
    },

    /**
     * Get my current subscription
     * @returns {Promise<Object>}
     */
    getMySubscription: async () => {
        return api.get('/user/subscriptions/my');
    },

    /**
     * Subscribe to a plan
     * @param {string} planId - Plan ID
     * @param {Object} data - Payment data
     * @returns {Promise<Object>}
     */
    subscribe: async (planId, data = {}) => {
        return api.post(`/user/subscriptions/subscribe/${planId}`, data);
    },

    /**
     * Cancel subscription
     * @returns {Promise<Object>}
     */
    cancel: async () => {
        return api.post('/user/subscriptions/cancel');
    },

    /**
     * Get current subscription + real usage counts (offers/requests/catalogs)
     * @returns {Promise<Object>}
     */
    getUsage: async () => {
        return api.get('/user/subscriptions/usage');
    },

    /**
     * Check subscription status
     * @returns {Promise<Object>}
     */
    checkStatus: async () => {
        return api.get('/user/subscriptions/status');
    }
};

export default subscriptionService;
